/**
 * @param {*} filePath
 * @param {*} fileUrl
 * @returns {ToothPartsDO | null}
 */

export const getToothPartsDOFromFilePath = async (filePath, fileUrl) => {
  const regex = /.*__(LOWER|UPPER)__TOOTH_(\d+)_(ATTACH|BITESTOP|CUTOUT|HOOK|SLIT).([^\s.]+)$/i;
  const match = filePath.match(regex);
  if (match) {
    const toothGumType = match[1];
    const toothIndex = parseInt(match[2], 10);
    const toothPartsType = match[3];
    const fileType = match[4];
    return {
      toothGumType,
      toothIndex,
      toothPartsType,
      fileUrl,
      fileType,
      filePath,
    };
  }
  return null;
};
